import { render, staticRenderFns } from "./btn-check-group.vue?vue&type=template&id=5014369a&scoped=true"
import script from "./btn-check-group.vue?vue&type=script&lang=ts"
export * from "./btn-check-group.vue?vue&type=script&lang=ts"
import style0 from "./btn-check-group.vue?vue&type=style&index=0&id=5014369a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5014369a",
  null
  
)

export default component.exports